import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "react-i18next";
import { X, Mail } from "lucide-react";

export default function EmailVerifyBanner({ onDismiss }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified !== false || dismissed) return null;

  return (
    <div className="bg-volt/10 border-b border-volt/20">
      <div className="max-w-6xl mx-auto px-5 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm">
          <Mail className="h-4 w-4 text-volt shrink-0" />
          <span className="text-foreground/80">{t("verify_email.banner_text")}</span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => navigate("/verify-email")}
            className="text-xs bg-volt text-background px-3 py-1.5 font-bold tracking-wider"
          >
            {t("verify_email.banner_verify")}
          </button>
          <button
            onClick={() => { setDismissed(true); onDismiss?.(); }}
            className="text-muted-foreground/60 hover:text-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
